import { Component, OnInit, Host } from '@angular/core';
import { MaximizeDirective } from '../../directives/maximize.directive';

@Component({
    selector: 'app-maximize',
    templateUrl: './maximize.component.html'
})
export class MaximizeComponent implements OnInit {
    expandToggle: string = "expand";
    constructor(@Host() private maximaizeDirective: MaximizeDirective) { }

    ngOnInit() {

    }

    maximizeIbox() {

        if (this.expandToggle == "expand") {
            this.maximaizeDirective.addFullScreen(true);
            this.expandToggle = "compress";
        }
        else {
            this.maximaizeDirective.addFullScreen(false);
            this.expandToggle = "expand";
        }
    }
}
